import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { InvestmentInstructionsVisualizationComponent } from '../investment-instructions-visualization.component';

import { InvestmentInstructionSubmission } from '../../../../../models/submissions/investment-instruction-submission';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { InstructionSubmissionUtils } from '../../../../../utils/instruction-submission-utils';

@Component({
  selector: 'app-previous-instructions-submission-visualization',
  templateUrl: './previous-instructions-submission-visualization.component.html',
  styleUrls: ['./previous-instructions-submission-visualization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviousInstructionsSubmissionVisualizationComponent
  extends InvestmentInstructionsVisualizationComponent
  implements OnChanges
{
  @Input() submission!: InvestmentInstructionSubmission;
  @Input() label: string = $localize`Current`;

  @ViewChildren('grid') gridElements!: QueryList<ElementRef>;

  private _submission = new BehaviorSubject<InvestmentInstructionSubmission | null>(null);
  public submission$ = this._submission.pipe(
    filter((submission): submission is InvestmentInstructionSubmission => !!submission)
  );

  public distributionsAreEqual$ = this.submission$.pipe(
    map(submission => {
      return InstructionSubmissionUtils.distributionsAreEqual(submission?.previous?.investmentInstructions);
    }),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public instructionsGroupedByAccount$ = combineLatest([this.distributionsAreEqual$, this.submission$]).pipe(
    map(([distributionsAreEqual, submission]) => {
      return InstructionSubmissionUtils.groupInvestmentInstructionsByAccount(
        submission.previous.investmentInstructions,
        submission.affectedAccounts,
        distributionsAreEqual,
        submission.accountType
      );
    })
  );

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.submission) {
      this._submission.next(this.submission ?? null);

      // If no forced columns are set, calculate using the longest instruction length
      if (!this.forcedColumns) {
        const longestInstructionLength = InstructionSubmissionUtils.calculateLongestInstructionLength(
          this.submission.previous.investmentInstructions
        );
        this._forcedColumns.next(longestInstructionLength);
      }
    }
  }
}
